<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料出库单登记</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <material-out ref="create" :userData="userData" :formByFather="form"></material-out>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交材料出库单登记</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import MaterialOut from '@/page/form/materialOut'
  export default {
    components: {
      // ApprovalItemByCustom,
      MaterialOut,
      // ApprovalItem,
      // Attachments,
    },
    // mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          houseId: '',
          outTime: '',
          materials: [],
          purpose: '',
          type: '维修',
          json: true,
        },

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.params.houseId && this.$route.params.houseId != 0) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }
    },
    methods: {
      // 提交使用材料申请单
      SubmitMaterial() {
        this.form = this.$refs.create.getFromData()

        this.formLoading = true
        let _url = '/storage/material/out/order'

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          this.$message.success("提交材料出库单成功")
          this.$router.push('/Storage/MaterialOutList/' + this.form.houseId)
        }, (res) => {
          this.formLoading = false
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/materialOut.vue